import Hero from "../sections/Hero";
import EditorialMarquee from "../sections/EditorialMarquee";
import Features from "../sections/Features";
import Manifesto from "../sections/Manifesto";
import Testimonials from "../sections/Testimonials";
import FAQ from "../sections/FAQ";
import BlogPreview from "../sections/BlogPreview";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      {/* <EditorialMarquee /> */}
      <Features />
      <Manifesto />
      <Testimonials />
      <BlogPreview />
      <FAQ />
    </div>
  );
}
